import React, { Component } from "react";
import PropTypes from "prop-types";

import ContactRow from "./ContactRow";
import AddableRow from "../AddableRow";
import { v4 as uuid } from 'uuid';

const emptyRow = {
  name: "",
  phone: "",
  email: "",
  isVisible: 1,
};

class ContactsList extends Component {
  constructor(props) {
    super(props);

    for (const item of props.list) {
      item.rowKey = uuid();
    }

    this.state = {
      list: props.list || []
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.list && nextProps.list !== this.state.list) {
      this.setState({
        list: nextProps.list
      });
    }
  }

  handleItemChange = (name, value, index) => {
    const { list } = this.state;
    const item = list[index];
    item[name] = value;
    list[index] = item;
    this.setState(
      {
        list
      },
      this.updateState
    );
  };

  addRow = () => {
    const newItem = { ...emptyRow };
    newItem.rowKey = uuid();
    this.setState(
      prevState => ({
        list: [...prevState.list, newItem]
      }),
      this.updateState
    );
  };

  removeRow = rowKey => {
    var { list } = this.state;
    list = list.filter((item) => { return item.rowKey !== rowKey})

    this.setState(
      {
        list
      },
      this.updateState
    );
  };

  updateState = () => {
    this.props.updateState(this.state.list, "contacts");
  };

  render() {
    const { isEditMode, showDeleteAction, hideIsVisibleField } = this.props;
    const { list } = this.state;

    return (
      <div className="contacts-list">
        {list.map((row, key) => (
          <AddableRow
            key={row.rowKey}
            rowKey={row.rowKey}
            onRemove={this.removeRow}
            showDeleteAction={showDeleteAction}
          >
            <ContactRow
              rowData={row}
              isEditMode={isEditMode}
              rowKey={key}
              hideIsVisibleField={hideIsVisibleField}
              onChange={this.handleItemChange}
            />
          </AddableRow>
        ))}

        <div className="add-row-button" onClick={this.addRow}>
          <i className="fi flaticon-add" />
          <span className="description">Добавить контакт</span>
        </div>
      </div>
    );
  }
}

ContactsList.propTypes = {
  isEditMode: PropTypes.bool,
  showDeleteAction: PropTypes.bool,
  list: PropTypes.array,
  hideIsVisibleField: PropTypes.bool,
  updateState: PropTypes.func
};

export default ContactsList;



// WEBPACK FOOTER //
// ./components/ClientForm/Contacts/ContactsList.js